module.exports = __webpack_public_path__ + "img/logo.0cf8e311.svg";